import { defineStore } from 'pinia'
import { $http } from '@/composables'

// Types — kept only for the closed-ticket SupportDetail overlay, which
// renders the rich timeline (`status_history`) that the SDK doesn't expose.

export interface Attachment {
  id: number
  message_id?: number
  file_name: string
  content_type: string
  size_bytes: number
  download_url?: string
  created_at: string
}

export interface Message {
  id: number
  ticket_id: number
  author_type: 'customer' | 'agent'
  author_id: number
  body: string
  internal_note: boolean
  created_at: string
  attachments?: Attachment[]
}

export interface StatusHistoryItem {
  from_status: {
    id: number
    name: string
  }
  to_status: {
    id: number
    name: string
  }
  changed_at: string
}

export interface Ticket {
  id: number
  subject: string
  description?: string
  status_id: number
  priority: string
  created_at: string
  updated_at: string
  last_message_at?: string
  channel: string
  messages?: Message[]
  status_history?: StatusHistoryItem[]
}

// FeedbackChoice / TicketFeedback live in store/feedback.ts — that's the
// single source for feedback shapes (Nuxt auto-import picks one export
// when names collide).

export const useTicketStore = defineStore('ticket', {
  state: () => ({
    currentTicket: null as Ticket | null,
    loading: false,
    error: null as string | null,
  }),

  actions: {
    async getTicket(id: number): Promise<Ticket | null> {
      this.loading = true
      this.error = null
      try {
        const response: any = await $http.get(`tickets/${id}`)
        // status_history payload.status_history içinde geliyor, ticket objesine ekle
        this.currentTicket = {
          ...response.payload.ticket,
          status_history: response.payload.status_history || [],
        }
        return this.currentTicket
      } catch (error: any) {
        this.error = error.message
        return null
      } finally {
        this.loading = false
      }
    },

    clearCurrentTicket() {
      this.currentTicket = null
      this.loading = false
      this.error = null
    },

    clearState() {
      this.currentTicket = null
      this.loading = false
      this.error = null
    },
  },
})
